/**
 * Design tokens specific to the edit-object redesign. The project's global
 * MUI theme already uses Ali Red (#841617) and Libre Baskerville for h1,
 * so these tokens cover only the values the design adds beyond the theme:
 * a slate/ink color scale, soft red surface colors, motion timings, and
 * elevation/focus shadows used by the new primitives.
 *
 * Imported by edit-object components via `sx` props, not registered
 * globally — keeps the redesign visually scoped while we soak the flag.
 */

export const EDIT_OBJECT_TOKENS = Object.freeze({
  color: {
    aliRed700: '#841617',
    aliRed800: '#6f1314',
    aliRed100: '#f7e9e9',
    aliRed050: '#fbf4f4',
    slate900: '#141a24',
    slate700: '#232F3E',
    slate500: '#4a5767',
    slate300: '#8a94a3',
    ink900: '#000000',
    ink700: '#2a2a2a',
    ink500: '#555555',
    ink400: '#888888',
    line: '#C1C1C1',
    lineSoft: '#E4E4E4',
    paper: '#ffffff',
    canvas: '#F0F0F0',
    canvasDim: '#E8E8E8',
    success: '#2e7d32',
    successSurface: '#f1f8f3',
    successBorder: '#cfe5d2',
    warning: '#ed6c02',
    danger: '#b71c1c',
    dangerSurface: '#fff0f0',
    dangerBorder: '#f3d3d3',
  },
  radius: {
    sm: 4,
    md: 6,
  },
  shadow: {
    s1: '0 1px 2px rgba(0,0,0,.08), 0 1px 3px rgba(0,0,0,.04)',
    s2: '0 2px 4px rgba(0,0,0,.08), 0 3px 6px rgba(0,0,0,.05)',
    focus: '0 0 0 3px rgba(132,22,23,.25)',
  },
  motion: {
    durationMs: 225,
    ease: 'cubic-bezier(.4,0,.2,1)',
  },
  font: {
    serif: '"Libre Baskerville", Georgia, serif',
    sans: '"Open Sans", system-ui, Arial, sans-serif',
  },
} as const);
